// extracted by mini-css-extract-plugin
module.exports = {"zemogaBenefits":"bP_fK","cardWrapper":"bP_N","imageWrapper":"bP_K","infoCard":"bP_fL","benefitsHeaderContainer":"bP_fM","sectionHeader":"bP_bb","title":"bP_S","summary":"bP_by"};